import React, { useContext } from "react";

import Image from "next/image";

import darkFallback from "shared/assets/images/large_dark_fallback.jpg";
import lightFallback from "shared/assets/images/large_light_fallback.jpg";
import GlobalContext from "shared/providers/context/GlobalContext";
import { formatBrazilianCurrency } from "shared/utils/formatBrazilianCurrency";

import { useCheckoutOnepageOffersContext } from "@CheckoutOnepageOffers/provider/useCheckoutOnepageOffersContext";
import { priceFormatter } from "@payment/utils/priceFormatter";

import {
  Container,
  SubTitle,
  Title,
  WrapperImage,
  WrapperText,
} from "./styles";

const ProductInfoMobile = () => {
  const { state } = useContext(GlobalContext);
  const { offer } = useCheckoutOnepageOffersContext();

  const lastInstallment = offer?.installments?.filter(
    (installment) => installment.installment === offer.offer.max_installments,
  )[0];

  const isDarkMode = state.theme.value === "dark";
  const emptyImage = isDarkMode ? darkFallback : lightFallback;

  return (
    <Container>
      <WrapperImage>
        <Image
          src={offer?.group?.logo_horizontal || emptyImage.src}
          width={160}
          height={90}
          alt=""
        />
      </WrapperImage>

      <WrapperText>
        <Title>{offer?.group?.title}</Title>

        <SubTitle>
          {offer?.installments ? (
            <>
              {offer.offer?.max_installments}x de R${" "}
              {priceFormatter(lastInstallment.value)} ou{" "}
              {formatBrazilianCurrency(Number(offer?.offer?.price))}
            </>
          ) : (
            <>{formatBrazilianCurrency(Number(offer?.offer?.price))}</>
          )}
        </SubTitle>
      </WrapperText>
    </Container>
  );
};

export default ProductInfoMobile;
